import { API_URL, EXCHANGE_NODE_BASE_URL } from './application';

const wrapWithAPIUrl = <T>(object: T): T => {
  const temp = {};

  // @ts-expect-error ...
  Object.entries(object).forEach(([key, value]) => {
    // @ts-expect-error ...
    temp[key] = `${API_URL}${value}`;
  });

  return temp as T;
};

export const user = wrapWithAPIUrl({
  login: '/login',
  impersonation: '/login/impersonation',
  root: '/user',
  me: '/user/me',
  access: '/users/access',
  users: '/users',
});

export const ssp = wrapWithAPIUrl({
  list: '/ssp',
});

export const dsp = wrapWithAPIUrl({
  list: '/dsp',
});

export const samples = wrapWithAPIUrl({
  list: '/samples',
  samplesRequest: '/samples/request',
});

export const list = wrapWithAPIUrl({
  v2: '/white-and-black-lists',
  v2Delete: '/white-and-black-lists/:id',
});

export const statistics = {
  hourly: {
    dsp: (id = null) => `${API_URL}/statistics/hourly/dsp${id ? `/${id}` : ''}`,
    ssp: (id = null) => `${API_URL}/statistics/hourly/ssp${id ? `/${id}` : ''}`,
    common: {
      ssp: (id = null) => `${API_URL}/statistics/hourly/common/ssp${id ? `/${id}` : ''}`,
      dsp: (id = null) => `${API_URL}/statistics/hourly/common/dsp${id ? `/${id}` : ''}`,
      dspV1: (id = null) => `[v1]${API_URL}/statistics/hourly/common/dsp${id ? `/${id}` : ''}`,
      sspV1: (id = null) => `[v1]${API_URL}/statistics/hourly/common/ssp${id ? `/${id}` : ''}`,
      partner: (id: unknown) => `${API_URL}/statistics/hourly/common/partner/${id || ''}`,
    },
    total: `${API_URL}/statistics/hourly/common/total`,
    totalEndpoint: `${API_URL}/statistics/hourly/common/total/endpoint`,
  },
  eventLogs: () => `${API_URL}/eventLogs`,
  qps: `${API_URL}/statistics/qps`,
  v2: `${API_URL}/v2/statistics`,
  v2ExtraCols: `${API_URL}/v2/statistics/extra-cols`,
  v2Export: `${API_URL}/v2/statistics/export`,
  v2LastHourSsps: `${API_URL}/v2/statistics/last-hour/ssps`,
  v2LastHourDsps: `${API_URL}/v2/statistics/last-hour/dsps`,
  predictionsV2: `${API_URL}/v2/predictions`,
  predictionsV2Export: `${API_URL}/v2/predictions/export`,
};

export const usersyncStatistics = wrapWithAPIUrl({
  root: '/v2/usersync-statistics',
  export: '/v2/usersync-statistics/export',
});

export const responseTimeStatistics = wrapWithAPIUrl({
  root: '/v2/response-time-statistics',
});

const globalLists = {
  root: `${API_URL}/globalLists`,
  categories: `${API_URL}/globalLists/categories`,
};

const documentation = wrapWithAPIUrl({
  list: '/documentation',
  item: '/documentation/:id',
});

const endpoints = {
  user,
  ssp,
  dsp,
  samples,
  statistics,
  list,
  documentation,
  usersyncStatistics,
  responseTimeStatistics,
  sspIabCategories: `${API_URL}/ssps/iabCategories`,
  sspSellerInfo: `${API_URL}/ssp/:id/sellerInfo`,
  dspSellerInfo: `${API_URL}/dsp/:id/sellerInfo`,
  globalLists,
  lists: `${API_URL}/lists`,
  exchangeNodeBaseUrl: EXCHANGE_NODE_BASE_URL,
  asianExchangeBaseUrl: 'http://sg.justbidit.xyz:8800',
};

export type Endpoints = typeof endpoints;

export default endpoints;
